import React, { Component } from 'react';
import { navigate } from '@reach/router';
import { classname } from 'utils';
import { Image } from 'elements';
import tokens from '../../elements/Face/Face.tokens';

import './BrandPassportPopup.css';

export default class BrandPassportPopup extends Component {
  cl = classname('brand-passport-popup');

  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  componentDidMount() {
    if (!process.browser) return;

    // Проверяем, нужно ли показывать попап
    if (this.shouldShowPopup()) {
      // Показываем попап с небольшой задержкой для лучшего UX
      setTimeout(() => {
        this.setState({ isVisible: true });
      }, 1000);
    }
  }

  shouldShowPopup = () => {
    // Проверяем, когда попап был закрыт
    const closedTimestamp = localStorage.getItem('brandPassportPopup');

    if (!closedTimestamp) {
      // Попап никогда не показывался
      return true;
    }

    // Проверяем, прошло ли 24 часа с момента закрытия
    const now = Date.now();
    const timePassed = now - parseInt(closedTimestamp, 10);
    const oneDayInMs = 24 * 60 * 60 * 1000; // 24 часа в миллисекундах

    return timePassed >= oneDayInMs;
  };

  componentDidUpdate(prevProps, prevState) {
    // Блокируем/разблокируем скролл при изменении видимости попапа
    if (prevState.isVisible !== this.state.isVisible) {
      if (this.state.isVisible) {
        document.documentElement.classList.add('popup-open');
      } else {
        document.documentElement.classList.remove('popup-open');
      }
    }
  }

  componentWillUnmount() {
    // Разблокируем скролл при размонтировании компонента
    document.documentElement.classList.remove('popup-open');
  }

  handleClose = () => {
    this.setState({ isVisible: false });
    // Сохраняем timestamp закрытия для показа через 24 часа
    localStorage.setItem('brandPassportPopup', Date.now().toString());
  };

  handleGetPassport = () => {
    // Сохраняем timestamp закрытия для показа через 24 часа
    localStorage.setItem('brandPassportPopup', Date.now().toString());
    this.setState({ isVisible: false });
    // Переходим на страницу заказа
    navigate('/order');
  };

  render() {
    const { isVisible } = this.state;

    if (!isVisible) {
      return null;
    }

    return (
      <div className={this.cl('overlay')}>
        <div className={this.cl('container')}>
          <button className={this.cl('close-button')} onClick={this.handleClose} aria-label="Закрыть попап">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.597656 1.10156L15.2711 15.7751" stroke="white" stroke-width="1.68889" />
              <path d="M15.2734 0.59375L0.599944 15.2672" stroke="white" stroke-width="1.68889" />
            </svg>
          </button>

          <div className={this.cl('content')}>
            <h2 className={this.cl('title')}>Позиционирование за&nbsp;2&nbsp;недели</h2>

            <p className={this.cl('description')}>
              Создадим паспорт вашего бренда&nbsp;&mdash; стратегический инструмент для эффективных коммуникаций
              и&nbsp;увеличения продаж.
            </p>

            <blockquote className={this.cl('quote')}>
              «Документ, который точно объясняет подрядчикам, маркетингу и&nbsp;клиентам, в&nbsp;чём вы&nbsp;лучшие».
            </blockquote>

            <div className={this.cl('bottom')}>
              <div className={this.cl('author')}>
                <div className={this.cl('author-avatar')}>
                  <Image
                    src="/peoples/chulkov/chulkov-round.png"
                    alt="Сергей Чулков"
                    width={tokens.image.m}
                    height={tokens.image.m}
                    className={this.cl('author-photo')}
                  />
                  {/* <img src="/images/sergey-chulkov.svg" alt="Сергей Чулков" className={this.cl('author-photo')} /> */}
                </div>
                <div className={this.cl('author-info')}>
                  <div className={this.cl('author-name')}>Сергей Чулков</div>
                  <div className={this.cl('author-title')}>Тимлид команды стратегов</div>
                </div>
              </div>
              <button className={this.cl('cta-button')} onClick={this.handleGetPassport}>
                Получить паспорт бренда
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
